export default "__VITE_ASSET__okpDjZsm__"